import { initMicrofrontend } from '../initMicrofrontend';
import { getContext } from '../getContext';
import { createReduxStore } from '../../../../shared/utils/redux';

export const runApp = () => {
  const { config, httpApi, logger, telemetry, widgetResultObserver } = getContext();

  const storeContext = {
    config,
    httpApi,
    logger,
    telemetry,
    resolveWidgetResult: widgetResultObserver.resolve,
  };

  const store = createReduxStore(storeContext);

  initMicrofrontend({ config, httpApi, logger, telemetry, store, widgetResultObserver });
};
